import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as api from '../../../api';
import ListItem from '../ListItem/ListItem';
import './Tag.css';
import { saveLastLocation } from '../../../redux/actions';
import TagList from './TagList/TagList';
import { PATH } from '../../../constants';

class Tag extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listOpen: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.saveLastLocation(this.props.match.url);
  }

  render() {
    const { tag } = this.props.match.params;
    const dataArray = api.getTagData(tag).sort((a, b) => {
      const at = a[1].title.toUpperCase();
      const bt = b[1].title.toUpperCase();
      if (at < bt) return -1;
      else if (at > bt) return 1;
      return 0;
    });
    const items = dataArray.map(item => (
      <ListItem
        key={item[0]}
        grid={this.props.grid}
        itemData={item}
      />
    ));

    return (
      <div>
        <div id="tag-head">{tag}</div>
        <div className="list-switch-wrap">
          <button
            className={`tag-list-switch ${this.state.listOpen ? 'open' : ''}`}
            onClick={() => {
              this.setState(prevState => ({
                listOpen: !prevState.listOpen,
              }));
            }}
          >
            <div className="sw-title">Seznam tagů</div>
            <div className="ico-wrap">
              <img
                className="ico"
                src={`${PATH.IMG}ico/ico-tags-list.png`}
                alt="Seznam tagů"
              />
            </div>
          </button>
        </div>
        <TagList
          open={this.state.listOpen}
          currentTag={tag}
        />
        <div>{items}</div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  grid: state.resize.grid,
});

const mapDispatchToProps = dispatch => ({
  saveLastLocation: lastLocation => dispatch(saveLastLocation(lastLocation)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Tag);



// WEBPACK FOOTER //
// ./src/components/App/Tag/Tag.js